module.exports = {
  publicPath: '',
  outputDir: 'dist',
  assetsDir: 'static',
  lintOnSave: true,
  transpileDependencies: [],
  devPort: 16000,
  providePlugin: {},
  build7z: false,
  buildGzip: false,
  imageCompression: false,
  pwa: true,
}
